module.exports = __webpack_public_path__ + "static/media/credit-card.2afec668.svg";